

const reportsDoughnutChartData = {
  labels: ["Living Room", "Kitchen", "Attic", "Garage", "Basement"],
  datasets: {
    label: "Consumption",
    backgroundColors: ["primary", "secondary", "info", "success", "warning"],
    data: [15, 20, 13, 32, 20],
  },
};

export default reportsDoughnutChartData;
